<template>
  <domain-nameservers :domainid="domainid"/>
</template>

<script>
import DomainNameservers from '@/components/Domains/DomainNameservers'

export default {
  name: 'DomainNameserversView',
  components: {
    DomainNameservers
  },
  props: {
    domainid: {
      type: [String, Number],
      required: true,
    }
  },

}
</script>
